<template>
  <div class="FX_L_box">
    <el-button
      class="L_btn"
      type="primary"
      v-for="(item, index) in navigatorList"
      :key="index"
      :class="$route.name && $route.name.includes(item.name) ? 'ck_L_btn' : ''"
      @click="toPage(item.path)"
    >
      <span style="font-size: 1.5rem"><i :class="item.icon"></i></span><br />
      <span
        style="font-size: 0.7rem; font-family: 微軟正黑體;line-height: 15px;"
        v-html="item.showName.replace('\n', '</br>')"
      >
      </span>
    </el-button>
    <el-button
      class="L_btn"
      type="primary"
      @click="openPage('https://tyc.tycg.gov.tw/PageVRYEB?fid=57')"
    >
      <span style="font-size: 1.5rem"><i class="el-icon-s-claim"></i></span
      ><br />
      <span
        style="font-size: 0.7rem; font-family: 微軟正黑體;line-height: 15px;"
        v-html="'場地租借'"
      >
      </span>
    </el-button>

    <el-button
      class="L_btn"
      type="primary"
      @click="openPage('https://forms.gle/PTjf5wpb9JjGjpKx7')"
    >
      <span style="font-size: 1.5rem"><i class="el-icon-s-platform"></i></span
      ><br />
      <span
        style="font-size: 0.7rem; font-family: 微軟正黑體;line-height: 15px;"
        v-html="'機台租借'"
      >
      </span>
    </el-button>
  </div>
</template>

<script>
export default {
  // created() {
  //     this.getBreadcrumb()
  // },
  data() {
    return {
      navigatorList: this.$router.options.routes.filter(
        (x) => x.showName !== undefined
      ),
    };
  },
  // watch: {
  //     $route() {
  //         console.log(this.$route)
  //     }
  // },
  methods: {
    openPage(path) {
      window.open(path);
    },
    toPage(path) {
      if (this.$route.path === path) return;
      this.$router.push({ path });
    },
    // getBreadcrumb() {
    //     // let matched = this.$route.matched.filter(item => item.name)
    //     console.log(this.$router.options.routes)
    //     this.levelList =
    // }
  },
};
</script>

<style scoped>
.home .FX_box {
  background-color: #ffffff;
  width: 800px;
  min-height: 700px;
  display: inline-block;
  border-radius: 10px;
  box-shadow: 4px 4px 12px -2px #d6d6d6;
  overflow: hidden;
  text-align: left;
}

.home .FX_L_box {
  display: inline-block;
  background: #fdfdfd;
  width: 100px;
  min-height: 700px;
  text-align: center;
  vertical-align: top;
}
.home .L_btn {
  width: 70px;
  height: 70px;
  text-align: center;
  /* font-weight: bold; */
  line-height: 18px;
  display: inline-block;
  margin-top: 1.2rem;
}
.home .el-button {
  padding: 0;
}
.home .ck_L_btn {
  color: #fff !important;
  background-color: #3c50e0 !important;
  border-color: #3c50e0 !important;
}
.home .L_btn {
  color: #c7c7c7;
  background-color: #fdfdfd;
  border-color: #fdfdfd;
}
.home .el-button + .el-button {
  margin-left: 0px;
}
.home .FX_R_box {
  background-color: #ffffff;
  display: inline-block;
  width: 680px;
  min-height: 700px;
  vertical-align: top;
}
</style>
